import { HeatmapRecordingService } from './ClarityHeatmapRecordingService';

export class ClarityHeatmapRecordingServerService implements HeatmapRecordingService {
  async initialize() {
    return;
  }

  async startRecording() {
    return;
  }

  identifyUser() {
    return false;
  }
  giveCookieConsent() {
    return false;
  }

  triggerCustomEvent() {
    return false;
  }

  addCustomTag() {
    return false;
  }

  markImportantSession() {
    return false;
  }

  revokeCookieConsent() {
    return false;
  }
}
